import type { SendCodeScene } from '@/hooks/useSendCode'

export enum VerActionType {
  PhoneVer = 'PhoneVer',
  EmailVer = 'EmailVer',
  GoogleVer = 'GoogleVer',
}

// 验证操作项接口
export interface VerActionItem {
  icon: string
  title: string
  description: string
  actionType: VerActionType
}

// 组件属性接口
export interface SelectVerificationProps {
  /** 验证码发送场景 */
  scene: SendCodeScene
  /** 验证成功后的回调 */
  onSuccess: (data: {
    actionType: VerActionType
    account: string
  }) => void
  /** 是否显示标题 */
  showTitle?: boolean
  /** 自定义标题 */
  title?: string
  /** 是否显示手机号验证选项 */
  showPhoneOption?: boolean
  /** 自定义类名 */
  className?: string
}

// 重新导出 SendCodeScene 供外部使用
export type { SendCodeScene }
